import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Button, Container } from '@superdispatch/ui-lab';
import { useNavigate } from 'react-router-dom';
import { viewportHeight } from 'shared/layout/NavigationHeaderBannerHeight';
import styled from 'styled-components';

const StyledContainer = styled(Container)`
  background-color: ${ColorDynamic.Silver200};
  display: flex;
  align-items: center;
  height: ${viewportHeight()};
  text-align: center;
`;

export function SuperPayErrorPage() {
  const navigate = useNavigate();

  return (
    <StyledContainer>
      <Stack space="small">
        <Typography>
          You don’t have account permissions to
          <br />
          set up SuperPay, contact your manager
          <br />
          for assistance.
        </Typography>
        <Button
          variant="neutral"
          onClick={() => {
            navigate(-1);
          }}
        >
          Go Back
        </Button>
      </Stack>
    </StyledContainer>
  );
}
